import ApprovalService from "./approvalService";
import { bound } from "@frui.ts/helpers";
import AccountingDocumentCandidateResponse from "../entities/accountingDocumentCandidateResponse";
import AccountingDocumentCandidateApprovalType from "../entities/accountingDocumentCandidateApprovalType";
import type AccountingDocumentCandidateDetailResponse from "../entities/accountingDocumentCandidateDetailResponse";

export default class AccountingDocumentsApprovalService extends ApprovalService<
  AccountingDocumentCandidateApprovalType,
  AccountingDocumentCandidateResponse | AccountingDocumentCandidateDetailResponse
> {
  @bound
  isApprovalProcessComplete(approvable: AccountingDocumentCandidateResponse) {
    const approvals = (approvable.approvals ?? []).flatMap(approval => approval.approvalType);

    return (
      approvals.includes(AccountingDocumentCandidateApprovalType.CommandOperator) &&
      approvals.includes(AccountingDocumentCandidateApprovalType.ChiefAccountant)
    );
  }

  @bound
  currentApproverPredecessor(): AccountingDocumentCandidateApprovalType | undefined {
    switch (this.whoAmI()) {
      case AccountingDocumentCandidateApprovalType.ChiefAccountant:
        return AccountingDocumentCandidateApprovalType.CommandOperator;
      case AccountingDocumentCandidateApprovalType.CommandOperator:
      default:
        return undefined;
    }
  }

  protected isCurrentStepReadyOrDoneForFactualAuditor(approvals: AccountingDocumentCandidateApprovalType[]) {
    return true;
  }

  protected isCurrentStepReadyOrDoneForCommandOperator(approvals: AccountingDocumentCandidateApprovalType[]) {
    return (
      approvals.length === 0 ||
      (approvals.length === 1 && approvals.includes(AccountingDocumentCandidateApprovalType.CommandOperator))
    );
  }

  protected isCurrentStepReadyOrDoneForChiefAccountant(approvals: AccountingDocumentCandidateApprovalType[]) {
    return (
      (approvals.length === 1 && approvals.includes(AccountingDocumentCandidateApprovalType.CommandOperator)) ||
      (approvals.length === 2 &&
        approvals.includes(AccountingDocumentCandidateApprovalType.CommandOperator) &&
        approvals.includes(AccountingDocumentCandidateApprovalType.ChiefAccountant))
    );
  }
}
